import {
  isEthereumClaimUndelegate,
  isEthereumDelegate,
  isEthereumUndelegate,
  isEthereumUndelegatePending,
} from '../staking/ethereum/staking-utils.js'
import {
  isPolygonClaimUndelegate,
  isPolygonDelegate,
  isPolygonUndelegate,
} from '../staking/matic/index.js'
import {
  calculateRewardsFromStakeTx,
  decodeEthLikeStakingTxInputAmount,
  decodePolygonStakingTxInputAmount,
} from './utils.js'

const getEthereumStakingTxData = ({ tx, currency }) => {
  if (
    ['delegate', 'undelegatePending', 'undelegate', 'claimUndelegate'].some(
      (stakeTx) => tx.data?.[stakeTx]
    ) &&
    tx.coinAmount.isZero
  )
    return

  const txAmount = tx.coinAmount.toDefaultString()

  if (isEthereumDelegate(tx)) {
    return { delegate: txAmount, txAmount }
  }

  // undelegate must be taken in consideration, if unstaked ETH is still
  // in the pool queue, undelgate transfers staked funds back inmediatly to the user
  if (isEthereumUndelegatePending(tx)) {
    const undelegatePending = currency
      .baseUnit(decodeEthLikeStakingTxInputAmount(tx))
      .toDefaultString()
    return {
      undelegatePending,
      txAmount,
    }
  }

  if (isEthereumUndelegate(tx)) {
    const undelegate = currency.baseUnit(decodeEthLikeStakingTxInputAmount(tx)).toDefaultString()
    return { undelegate, txAmount }
  }

  // In the case of the ETH being actually staked and earning,
  // unstake has a withdraw period, after that, unstaked can be claimed.
  if (isEthereumClaimUndelegate(tx)) {
    return { claimUndelegate: txAmount, txAmount }
  }
}

const getPolygonStakingTxData = ({ tx, currency }) => {
  if (
    ['delegate', 'undelegate', 'claimUndelegate'].some((stakeTx) => tx.data?.[stakeTx]) &&
    tx.coinAmount.isZero
  )
    return

  const txAmount = tx.coinAmount.toDefaultString()

  if (isPolygonDelegate(tx)) {
    const delegate = currency.baseUnit(decodePolygonStakingTxInputAmount(tx)).toDefaultString()
    // MATIC returned in unstake tx is always reward
    const rewards = calculateRewardsFromStakeTx({ tx, currency })
    return { delegate, txAmount, ...(rewards ? { rewards } : {}) }
  }

  if (isPolygonUndelegate(tx)) {
    const undelegate = currency.baseUnit(decodePolygonStakingTxInputAmount(tx)).toDefaultString()
    // MATIC returned in unstake tx is always reward
    const rewards = txAmount
    return { undelegate, txAmount, rewards }
  }

  if (isPolygonClaimUndelegate(tx)) {
    return { claimUndelegate: txAmount, txAmount }
  }
}

export const assetStakingTxData = {
  polygon: getPolygonStakingTxData,
  ethereum: getEthereumStakingTxData,
  ethereumholesky: getEthereumStakingTxData,
}
